import React, { useState } from 'react';
import { Modal } from '@material-ui/core';

import { increaseMaxAttempt } from '../../../services/apiService';

import { AddCircle } from '@material-ui/icons';

import { RefreshCounterContext } from '../index';

export default function IncreaseAttemptModal({ params }) {
  const setRefreshCounterFn = React.useContext(RefreshCounterContext);

  const [openModal, setOpenModal] = useState(false);

  const isNumAttemptEqualsMaxAttempt = () => {
    return params?.data?.attemptNumber === params?.data?.maxAttempts;
  };

  return (
    <div>
      <div
        className={`flex items-center h-full ${
          isNumAttemptEqualsMaxAttempt() ? 'text-blue-600 cursor-pointer' : ''
        } `}
        onClick={async () => {
          if (!isNumAttemptEqualsMaxAttempt()) return;
          setOpenModal(true);
        }}
      >
        {params?.data?.attemptNumber} / {params?.data?.maxAttempts}
        {isNumAttemptEqualsMaxAttempt() && <AddCircle className='mx-2' />}
      </div>

      <Modal
        open={openModal}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <div className='relative overflow-y-auto max-h-96 top-2 md:top-10 m-auto bg-white  rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600'>
          <div
            className='absolute right-2 top-2 cursor-pointer'
            onClick={() => {
              setOpenModal(false);
            }}
          >
            X
          </div>

          <h2 className='font-bold text-center'>
            Are you sure, you want to increase maximum number of attempts from{' '}
            {params?.data?.maxAttempts} to {params?.data?.maxAttempts + 1}?
          </h2>

          <hr />

          <div className='flex justify-end items-center mt-4'>
            <button
              className='bg-red-c3 p-1 px-2 rounded-md text-white'
              onClick={async () => {
                try {
                  const body = {
                    studentId: params?.data?.userId,
                    assignmentId: params?.data?.assignmentId,
                  };
                  await increaseMaxAttempt(body);
                } catch (e) {
                  console.error(e);
                }

                setOpenModal(false);
                setRefreshCounterFn((counter) => counter + 1);
              }}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
